module.exports = __webpack_public_path__ + "img/glucose_meter_grey.983749b8.svg";